export const MODES = {
    INBOUND: 'inbound',
    MANUAL: 'manual',
    PROGRESSIVE: 'progressive',
    PREVIEW: 'preview',
    DIGITAL: 'chat',
    BELNDED: 'blended'
}

export const LOG_TYPE = {
    INFO: 'info',
    WARN: 'warning',
    ERROR: 'error',
    LOG: 'log'
}

export const AGENT_STATE = {
    READY: 'READY',
    NOT_READY: 'Not Ready'
}

export const WEB_EVENTS = {
    welcome: 'welcome',
    newCall: 'newCall',
    dropCall: 'dropCall',
    agentCallAnswered: 'agentCallAnswered',
    agentCallDisconnected: 'agentCallDisconnected',
    performCallEvent: 'performCallEvent',
    decline: 'decline',
    agentReleaseWOACW: 'agentReleaseWOACW',
    agentLogoffByAdmin: 'agentLogoffByAdmin',
    agentReleaseByAdmin: 'agentReleaseByAdmin',
    busyAgent: 'busyAgent',
    agentRelease: 'agentRelease',
    pauseFromApi: 'pauseFromApi',
    callDetails: 'callDetails',
    incomingConferenceCall: 'incomingConferenceCall',
    conferenceStart: 'conferenceStart',
    conferenceEnd: 'conferenceEnd',
    incomingChat: 'incomingChat',
    chatonmulti: 'chatonmulti',
    inchatmulti: 'inchatmulti',
    custMediaMsg: 'custMediaMsg',
    custLocation: 'custLocation',
    custEnd: 'custEnd',
    closeTab: 'closeTab',
    agentAlert: "agentAlert",
    chatMessage: "chatMessage",
    InternalDial: "InternalDial",
    response: "response",
    agentTransferBusy: "agentTransferBusy",
    agentTransferEnd: "agentTransferEnd",
    agentPauseBySystem: "agentPauseBySystem",
    transcribeText: 'transcribeText',
    toolbarPause: "toolbarPause",
    toolbarRelease: "toolbarRelease",
    agentConferenceStart: "agentConferenceStart",
    AgentSubUserChat: "AgentSubUserChat",
    agentBarginStart: "agentBarginStart",
    agentBarginEnd: "agentBarginEnd"
}

export const SHORTCUT_KEYS = {
    CHANGE_MODE: ['Alt', 'm'],
    ACCEPT_CALL: ['Alt', 'a'],
    REJECT_CALL: ['Alt', 'r'],
    CONFERENCE: ['Alt', 'c'],
    TRANSFER: ['Alt', 't'],
    HOLD: ['Alt', 'h'],
    MUTE: ['Alt', 'm'],
    KEYPAD: ['Alt', 'k'],
    HANGUP_DISPOSITION: ['Alt', 'd'],
    DASHBOARD: ['Alt', 'd'],
    SUBMIT_DISPOSITION: ['Control', 's'],
    AGENT_TO_AGENT_CALL: ['Alt', 'Shift', 'a'],
    PERFORMANCE_TAB: ['Alt', 'p'],
    OUTBOUND_MESSAGE_ON_CALL: ['Alt', 'Shift', 'o'],
    OUTBOUND_MESSAGE: ['Alt', 'o'],
    HISTORY: ['Alt', 'h'],
    NOTIFICATIONS: ['Alt', 'n'],
    FORCE_READY_STATE: ['Alt', 'Shift', 'r'],
    CHANGE_STATE_TO_READY: ['Alt', 'Shift', 'y'],
    CHANGE_STATE_TO_PAUSE: ['Alt', 'Shift', 'p'],
    AUDIO_SETTINGS: ['Alt', 'Shift', 's'],

}

export const dashboardAgentList =
    [
        {
            "AgentState": "3",
            "SkillName": "salesforce_test, salesforce_test_chat",
            "IdleTime": "1681295056194",
            "CallMode": "8",
            "AgentName": "Sai Shiva Prasad"
        },
        {
            "AgentState": "2",
            "SkillName": "salesforce_test",
            "IdleTime": "1681291854150",
            "CallMode": "2",
            "AgentName": "Sai Bharath"
        },
        {
            "AgentState": "2",
            "SkillName": "salesforce_test, salesforce_test_chat",
            "IdleTime": "1681293745335",
            "CallMode": "2",
            "AgentName": "raj kumar"
        },
        {
            "AgentState": "1",
            "SkillName": "salesforce_test",
            "IdleTime": "1681290029504",
            "CallMode": "0",
            "AgentName": "Hari Haran"
        },
        {
            "AgentState": "1",
            "SkillName": "salesforce_test, salesforce_test_chat",
            "IdleTime": "1681294172942",
            "CallMode": "0",
            "AgentName": "Hari Prasad"
        }]

export const dashboardQueueCounter = [
]

export const sideMenuList = ['Dashboard', 'Performance', 'History', 'My CRM', 'Interaction Hub','Qa Agent Performance',"PA"];

export const AGENT_STATES = {
    "0": "LOGOUT",
    "1": "AUX",
    "2": "IDLE",
    "3": "BUSY",
    "4": "ACW",
    "5": "EXCEPTION",
    "7": "CALLING"
};

export const AGENT_MODES = {
    "0": "INBOUND",
    "1": "PREVIEW",
    "2": "MANUAL",
    "3": "PROGRESSIVE",
    "4": "BLENDED",
    "8": "Chat"
};

export const countryCodes = {
    "AF": "Afghanistan",
    "AX": "\u00c5land Islands",
    "AL": "Albania",
    "DZ": "Algeria",
    "AS": "American Samoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarctica",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BS": "Bahamas",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia, Plurinational State of",
    "BQ": "Bonaire, Sint Eustatius and Saba",
    "BA": "Bosnia and Herzegovina",
    "BW": "Botswana",
    "BV": "Bouvet Island",
    "BR": "Brazil",
    "IO": "British Indian Ocean Territory",
    "BN": "Brunei Darussalam",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodia",
    "CM": "Cameroon",
    "CA": "Canada",
    "CV": "Cape Verde",
    "KY": "Cayman Islands",
    "CF": "Central African Republic",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CX": "Christmas Island",
    "CC": "Cocos (Keeling) Islands",
    "CO": "Colombia",
    "KM": "Comoros",
    "CG": "Congo",
    "CD": "Congo, the Democratic Republic of the",
    "CK": "Cook Islands",
    "CR": "Costa Rica",
    "CI": "C\u00f4te d'Ivoire",
    "HR": "Croatia",
    "CU": "Cuba",
    "CW": "Cura\u00e7ao",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DK": "Denmark",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "EE": "Estonia",
    "ET": "Ethiopia",
    "FK": "Falkland Islands (Malvinas)",
    "FO": "Faroe Islands",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "France",
    "GF": "French Guiana",
    "PF": "French Polynesia",
    "TF": "French Southern Territories",
    "GA": "Gabon",
    "GM": "Gambia",
    "GE": "Georgia",
    "DE": "Germany",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Greece",
    "GL": "Greenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "HM": "Heard Island and McDonald Islands",
    "VA": "Holy See (Vatican City State)",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran, Islamic Republic of",
    "IQ": "Iraq",
    "IE": "Ireland",
    "IM": "Isle of Man",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "JE": "Jersey",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KP": "Korea, Democratic People's Republic of",
    "KR": "Korea, Republic of",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Lao People's Democratic Republic",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MO": "Macao",
    "MK": "Macedonia, the Former Yugoslav Republic of",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshall Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "FM": "Micronesia, Federated States of",
    "MD": "Moldova, Republic of",
    "MC": "Monaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Netherlands",
    "NC": "New Caledonia",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolk Island",
    "MP": "Northern Mariana Islands",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palestine, State of",
    "PA": "Panama",
    "PG": "Papua New Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines",
    "PN": "Pitcairn",
    "PL": "Poland",
    "PT": "Portugal",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "RE": "R\u00e9union",
    "RO": "Romania",
    "RU": "Russian Federation",
    "RW": "Rwanda",
    "BL": "Saint Barth\u00e9lemy",
    "SH": "Saint Helena, Ascension and Tristan da Cunha",
    "KN": "Saint Kitts and Nevis",
    "LC": "Saint Lucia",
    "MF": "Saint Martin (French part)",
    "PM": "Saint Pierre and Miquelon",
    "VC": "Saint Vincent and the Grenadines",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Sao Tome and Principe",
    "SA": "Saudi Arabia",
    "SN": "Senegal",
    "RS": "Serbia",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SX": "Sint Maarten (Dutch part)",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "SB": "Solomon Islands",
    "SO": "Somalia",
    "ZA": "South Africa",
    "GS": "South Georgia and the South Sandwich Islands",
    "SS": "South Sudan",
    "ES": "Spain",
    "LK": "Sri Lanka",
    "SD": "Sudan",
    "SR": "Suriname",
    "SJ": "Svalbard and Jan Mayen",
    "SZ": "Swaziland",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syrian Arab Republic",
    "TW": "Taiwan, Province of China",
    "TJ": "Tajikistan",
    "TZ": "Tanzania, United Republic of",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad and Tobago",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "TC": "Turks and Caicos Islands",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "United Arab Emirates",
    "GB": "United Kingdom",
    "US": "United States of America",
    "UM": "United States Minor Outlying Islands",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VE": "Venezuela, Bolivarian Republic of",
    "VN": "Viet Nam",
    "VG": "Virgin Islands, British",
    "VI": "Virgin Islands, U.S.",
    "WF": "Wallis and Futuna",
    "EH": "Western Sahara",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
};
export const styles = {
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        margin: '10px 0',
    },
    legend: {
        width: '100px', // Fixed width for legend
        textAlign: 'left',
        marginRight: '10px',
        fontWeight: 'bold',
        fontSize: '12px',
        color: 'rgb(102, 102, 102)',
    },
    barContainer: {
        flexGrow: 1, // Takes up remaining space
        backgroundColor: "#dae1e6",
        borderRadius: "0px 5px 5px 0px",
    },
    container: {
        width: '100%',
        height: '8px',
        borderRadius: '0px',
        overflow: 'hidden',
        margin: '0px',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    },
    progress: {
        height: '100%',
        backgroundColor: '#76c7c0',
        transition: 'width 0.3s ease',
        borderRadius: "0px 5px 5px 0px",
    },
    labelAfter: {
        marginLeft: '5px', // Space between the bar and the label
        fontWeight: 'bold',
        color: '#000',
        fontSize: '10px',
        whiteSpace: 'nowrap', // Prevents wrapping
    },
};







